import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styles } from "@repo/helpers";

import { Props } from "./types";

library.add(faSpinner);
export function Spinner(props: Props) {
	const { className, tag = "div", right, children, ...rest } = props;
	const wrapperClass = styles(className);
	const HtmlTag = tag as any;
	return (
		<HtmlTag {...rest} className={wrapperClass}>
			{renderSpinner()}
			{children}
			{renderSpinner(true)}
		</HtmlTag>
	);

	function renderSpinner(isRight?: boolean) {
		const wrapperClass = styles(className);
		if (right === isRight)
			return (
				<span className={wrapperClass}>
					<FontAwesomeIcon icon={faSpinner} pulse />
				</span>
			);
		return null;
	}
}
